/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The DXP main navigation menu id.
 * @export
 */
export const DXP_ID_MAIN_NAVIGATION = `main-navigation-menu`;

/**
 * The DXP main content area id.
 * @export
 */
export const DXP_ID_MAIN_CONTENT = `main-content`;
